export default __webpack_public_path__ + "static/media/Sparking Spear.91cac896.png";